// sampleData.js

export const unassignedData = [
     {
          Wallet: "01723456789",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },

        {
          Wallet: "01876543210",
          Name: "XYZ Telecom",
          Address: "81/1",
          Thana: "Dhaka",
          District: "Dhaka",
          assignedMAO: null,
        },
        {
          Wallet: "01876543210",
          Name: "ABCDE Telecom",
          Address: "82/1",
          Thana: "Dhaka",
          District: "Dhaka",
          assignedMAO: null,
        },
        {
          Wallet: "01876543210",
          Name: "Panda Telecom",
          Address: "83/1",
          Thana: "Dhaka",
          District: "Dhaka",
          assignedMAO: null,
        },
        {
          Wallet: "01723456789",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: {
            name: "Robiul",
            id: "78906756758",
          },
        },
   ];
   
   export const assignedData = [
     {
          Wallet: "01654387624",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
          Status: "unassigned",
          assignedMAO:
          {
            name: "Robiul",
            id: "78906756757",
          },
        },

        {
          Wallet: "01551234567",
          Name: "PQR Telecom",
          Address: "5/2",
          Thana: "Rajshahi",
          District: "Rajshahi",
          assignedMAO: {
            name: "Jane",
            id: "789012",
          },
        },
        {
          Wallet: "01723456789",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
          Status: "assigned",
          assignedMAO: {
            name: "Kamal",
            id: "78906756758",
          },
        },
   ];
   
   export const validatedData = [
     {
          Wallet: "01998245237",
          Name: "Panda telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },
        {
          Wallet: "01998245237",
          Name: "Rahim telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },
        {
          Wallet: "01998245237",
          Name: "Kajal telecom",
          Address: "15/7",
          Thana: "Mohonpur",
          District: "Rajshahi",
   
          assignedMAO: null,
        },
        {
          Wallet: "01998245237",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },

        {
          Wallet: "01998245237",
          Name: "Rosey2 telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },
        {
          Wallet: "01723456729",
          Name: "Khaibar telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: null,
        },
        {
          Wallet: "01876543210",
          Name: "XYZ Telecom",
          Address: "8/1",
          Thana: "Dhaka",
          District: "Dhaka",
          assignedMAO: null,
        },
        {
          Wallet: "01723456789",
          Name: "Rosey telecom",
          Address: "15/7",
          Thana: "Birganj",
          District: "Dinajpur",
   
          assignedMAO: {
            name: "Robiul",
            id: "78906756758",
          },
        },
   ];


